/**
 * Browser and system detection utilities for activity tracking.
 * Based on original GlobalActivity.js lines 31-78.
 */

export function detectBrowser(): string {
  const ua = navigator.userAgent
  if (ua.includes("Firefox")) return "Firefox"
  if (ua.includes("Chrome") && !ua.includes("Edg")) return "Chrome"
  if (ua.includes("Safari") && !ua.includes("Chrome")) return "Safari"
  if (ua.includes("Edg")) return "Edge"
  if (ua.includes("Trident")) return "IE"
  return "Unknown"
}

export function detectOS(): string {
  const platform = navigator.platform.toLowerCase()
  const ua = navigator.userAgent.toLowerCase()
  if (platform.includes("win")) return "Windows"
  if (platform.includes("mac")) return "macOS"
  if (platform.includes("linux")) return "Linux"
  if (/android/.test(ua)) return "Android"
  if (/iphone|ipad|ipod/.test(ua)) return "iOS"
  return "Unknown"
}

function calculateDownlinkQuality(downlink: number): number {
  if (downlink < 1.5) return 1
  if (downlink < 5) return 5
  return 10
}

function calculateRttQuality(rtt: number): number {
  if (rtt > 300) return 1
  if (rtt > 100) return 5
  return 10
}

export function getSystemInfo(battery: BatteryManager | null) {
  const connection = navigator.connection

  const connectionStats = connection
    ? {
        connectionType: connection.effectiveType,
        downlinkMbps: connection.downlink,
        rttMs: connection.rtt,
        downlinkQuality: calculateDownlinkQuality(connection.downlink),
        rttQuality: calculateRttQuality(connection.rtt),
      }
    : {
        connectionType: "unsupported",
        downlinkMbps: 0,
        rttMs: 0,
        downlinkQuality: 5,
        rttQuality: 5,
      }

  return {
    browserName: detectBrowser(),
    osName: detectOS(),
    zoomLevel: window.devicePixelRatio,
    screenResolution: `${window.screen.width}x${window.screen.height}`,
    viewportSize: `${window.innerWidth}x${window.innerHeight}`,
    batteryLevel: battery?.level ?? "unsupported",
    deviceMemory: navigator.deviceMemory === 8 ? "8+" : navigator.deviceMemory?.toString() || "unknown",
    hardwareConcurrency: navigator.hardwareConcurrency || "unknown",
    isCharging: battery?.charging ?? "unsupported",
    isOnline: navigator.onLine,
    ...connectionStats,
  }
}
